import "@/assets/style.scss";

import { createApp } from "vue";

// Import the PrimeFlex CSS.
import "primeflex/primeflex.css";

// Import the PrimeFlex theme. Any PrimeFlex compatible theme can be used.
import "primeflex/themes/primeone-light.css";

// Import the PrimeIcons.
import "primeicons/primeicons.css";

// Import the PrimeVue library.
import PrimeVue from "primevue/config";

// Import the Glycerine Viewer component.
import { GlycerineViewer, i18n } from "glycerine-viewer";

// Dynamic import for code splitting
import IIIFViewer from "@/viewer/IIIFViewer.vue";

// Create app with async component
const app = createApp(IIIFViewer);

// Use the PrimeVue library.
app.use(PrimeVue);

// Use the i18n plugin.
app.use(i18n);

// Register the Glycerine Viewer component globally.
app.component("GlycerineViewer", GlycerineViewer);

app.mount("#iiif_viewer");
